export function ColorShowcase() {
  return (
    <div className="p-6 max-w-4xl mx-auto space-y-6">
      <h2 className="text-2xl font-bold mb-4 text-foreground">
        Colores del Tema Rapyfact
      </h2>
      
      {/* Color Principal */}
      <div className="space-y-4">
        <h3 className="text-lg font-semibold">Color Primario #2BBEED (HSL: 192, 77%, 57%)</h3>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          <div className="bg-primary h-20 rounded-lg flex items-center justify-center text-primary-foreground font-medium">
            Primary
          </div>
          <div className="bg-rapyfact-blue h-20 rounded-lg flex items-center justify-center text-white font-medium">
            Rapyfact Blue
          </div>
          <div className="bg-rapyfact-blue-dark h-20 rounded-lg flex items-center justify-center text-white font-medium">
            Blue Dark
          </div>
        </div>
      </div>

      {/* Colores de marca */}
      <div className="space-y-4">
        <h3 className="text-lg font-semibold">Colores de Marca Rapyfact</h3>
        <div className="grid grid-cols-3 gap-4">
          <div className="bg-rapyfact-blue h-20 rounded-lg flex items-center justify-center text-white font-medium">
            Rapyfact Blue
          </div>
          <div className="bg-rapyfact-blue-light h-20 rounded-lg flex items-center justify-center text-primary-900 font-medium">
            Blue Light
          </div>
          <div className="bg-rapyfact-blue-dark h-20 rounded-lg flex items-center justify-center text-white font-medium">
            Blue Dark
          </div>
        </div>
      </div>

      {/* Ejemplos de botones */}
      <div className="space-y-4">
        <h3 className="text-lg font-semibold">Ejemplos de Componentes</h3>
        <div className="flex flex-wrap gap-4">
          <button className="bg-primary hover:bg-primary/90 text-primary-foreground px-4 py-2 rounded-md font-medium transition-colors">
            Botón Primario
          </button>
          <button className="border border-primary text-primary hover:bg-primary hover:text-primary-foreground px-4 py-2 rounded-md font-medium transition-colors">
            Botón Outline
          </button>
          <button className="bg-secondary text-secondary-foreground hover:bg-secondary/80 px-4 py-2 rounded-md font-medium transition-colors">
            Botón Secundario
          </button>
        </div>
      </div>

      {/* Card de ejemplo */}
      <div className="space-y-4">
        <h3 className="text-lg font-semibold">Card de Ejemplo</h3>
        <div className="bg-card border border-border rounded-lg p-6 shadow-sm">
          <h4 className="text-lg font-semibold mb-2 text-primary">
            Rapyfact - Facturación Electrónica
          </h4>
          <p className="text-muted-foreground mb-4">
            Solución integral para facturación electrónica en el sector salud.
          </p>
          <div className="flex items-center space-x-2">
            <div className="w-3 h-3 bg-primary rounded-full"></div>
            <span className="text-sm text-foreground">Estado: Activo</span>
          </div>
        </div>
      </div>
    </div>
  )
}